export default __webpack_public_path__ + "static/media/intoxicacion_monoxido_carbono_pediatria.db1862ec.pdf";